import { Amplify } from 'aws-amplify';
import { signIn } from 'aws-amplify/auth';
export const awsConfig = {
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_ADMIN_COGNITO_USERPOOL_ID,
            userPoolClientId: import.meta.env.VITE_ADMIN_COGNITO_CLIENT_ID,
            identityPoolId: import.meta.env.VITE_ADMIN_COGNITO_IDENTITY_POOL_ID,
        }
    },
    Storage: {
        S3: {
            bucket: import.meta.env.VITE_BUCKET_NAME,
            region: import.meta.env.VITE_REGION || 'us-east-1',
        }
    }
};
async function authenticateUser(username,password) {
    Amplify.configure(awsConfig)
    try {
    // Authenticate user using username/email and password
        const loginResponse = await signIn({
            username,
            password,
            options: {
                authFlowType: 'USER_PASSWORD_AUTH',
            },
        });
    } catch (error) {
        console.error('Authentication Error:', error);
    }
}

export default authenticateUser;


  